import React from 'react'
import { Theme } from 'features/ui/types'
import { useDisplayTheme, useSysTheme } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'
import styled from 'styled-components'
import { SystemTheme } from 'hooks/useUiState/types'
import WarningInfo from './WarningInfo'
import {
  StyledContainer,
  StyledContentContainer,
  StyledHeaderContainer,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledIconContainer,
  StyledContent,
  StyledActionContainer,
  StyledMetadataContainer
} from './index.css'

const StyledDivider = styled.div<{ $theme: SystemTheme }>`
  border-top: 1px solid ${({ $theme }) => $theme.common.divider[100]};
  margin-top: 10px;
  margin-bottom: 10px;
`

type PodcastSoundbiteFrameProps = {
  hasWarningInfo?: boolean
  dateItem: React.ReactNode
  domainIcon: React.ReactElement
  headerInfo: React.ReactElement
  postContent: React.ReactNode
  actionItems: React.ReactNode
  metadataItems: React.ReactNode
  mediaItems: React.ReactNode
  avatar: React.ReactNode
  photoUserTagContent?: React.ReactNode
  serialNumber: number
  onClick?: (content: any) => void
}

const PodcastSoundbiteFrame = ({
  headerInfo,
  dateItem,
  domainIcon,
  postContent,
  actionItems,
  metadataItems,
  mediaItems,
  avatar,
  photoUserTagContent,
  hasWarningInfo = false,
  serialNumber,
  onClick
}: PodcastSoundbiteFrameProps) => {
  const mode = useDisplayTheme() as Theme
  const theme = useSysTheme()

  return (
    <StyledContainer
      mode={mode}
      data-testid={`${AutomationId.soundbiteDefaultFrame.post}-${serialNumber}`}>
      {avatar}
      <StyledContentContainer onClick={onClick}>
        <StyledHeaderContainer>
          <StyledHeaderLeft>{headerInfo}</StyledHeaderLeft>
          <StyledHeaderRight mode={mode}>
            {dateItem}
            <StyledIconContainer>{domainIcon}</StyledIconContainer>
          </StyledHeaderRight>
        </StyledHeaderContainer>
        <StyledContent mode={mode}>{postContent}</StyledContent>
        <StyledDivider $theme={theme} />
        {photoUserTagContent}
        <StyledActionContainer>{actionItems}</StyledActionContainer>
        {hasWarningInfo && <WarningInfo />}
        {mediaItems}
        <StyledMetadataContainer mode={mode}>{metadataItems}</StyledMetadataContainer>
      </StyledContentContainer>
    </StyledContainer>
  )
}

export default PodcastSoundbiteFrame
